import * as React from 'react';
import * as mobxReact from 'mobx-react';
import classnames from 'classnames';
import { ISubWindowViewModel, SubWindowContext, SubWindowState } from './sub-window.viewmodel';

interface ISubWindowProps {
    subWindowViewModel: ISubWindowViewModel;
}

/**
 * SubWindow component, read properties from SubWindowViewModel and host passed in `componentToHost` within the sub-window
 * render minimized/maximized layout based on current status of viewModel
 */
const SubWindow = mobxReact.observer((props: ISubWindowProps) => {
    const { subWindowViewModel } = props;
    const subWindowDescriptor = subWindowViewModel.getParameters();
    const isMinimized = subWindowViewModel.stateFlag === SubWindowState.MINIMIZED;
    const isExpanded = subWindowViewModel.stateFlag === SubWindowState.EXPANDED;

    const className = classnames('sub-window', subWindowDescriptor?.className?.toString(), {
        'sub-window--minimized': isMinimized,
        'sub-window--maximized': !isMinimized,
    });

    const Layout = subWindowDescriptor.layoutComponent;
    const MinimizedLayout = subWindowDescriptor.minimizedLayoutComponent;

    const HostedComponent = subWindowDescriptor.componentToHost;

    return (
        <SubWindowContext.Provider value={subWindowViewModel}>
            <div className={className}>
                <div className='sub-window__minimized-container'>
                    <MinimizedLayout title={subWindowDescriptor.title} isExpandedByDefault={subWindowDescriptor.isExpandedByDefault} />
                </div>
                <div className='sub-window-container'>
                    <Layout
                        title={subWindowDescriptor.title}
                        additionalTitle={subWindowDescriptor.additionalTitle}
                        withExpand={subWindowDescriptor.withExpand}
                        isExpanded={isExpanded}
                        isExpandedByDefault={subWindowDescriptor.isExpandedByDefault}
                        subWindowClassname={subWindowDescriptor.subWindowClassname}
                    >
                        <HostedComponent { ...subWindowDescriptor.componentToHostProps} isExpanded={isExpanded} />
                    </Layout>
                </div>
            </div>
        </SubWindowContext.Provider>
    );
});

export { SubWindow, ISubWindowProps };
